import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  root: {
    width: '100%',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    background: theme.backgrounds.cardBackground,
    borderRadius: '5px',
    padding: '20px 80px 20px 20px',
    position: 'relative',
  },
  cardDescription: {
    fontSize: '16px',
    lineHeight: '19px',
    marginBottom: 8,
  },
  editButton: {
    position: 'absolute',
    right: 22,
    top: 'calc(50% - 16px)',
  },
  valueWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  cardValue: {
    color: theme.texts.subText,
    marginRight: 10,
  },
  not_received: {
    color: 'red',
  },
}))

export default useStyles
